import { useDiaryByIdQuery } from "@/features/diaries/api";
import DiaryTwoTabs from "@/features/diaries/components/DiaryTwoTabs";
import { createFileRoute, Outlet } from "@tanstack/react-router";

const FootWatch = () => {
    const { diaryId } = Route.useParams();
    const { data: diary } = useDiaryByIdQuery(diaryId);

    return (
        <section className="max-w-lg">
            {diary ? (
                <div className="mx-4 my-6 w-md">
                    <DiaryTwoTabs diary={diary} />
                </div>
            ) : null}
            <Outlet />
        </section>
    );
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/_view")({
    component: FootWatch,
});
